import { useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { swayyTheme } from "./swayyTheme";
import { swayyColors } from "./tokens";
import "./swayy.css";

interface SwayyThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Nested ThemeProvider for the Swayy workspace only.
 * Overrides the app-wide Swageazy theme while mounted.
 */
const SwayyThemeProvider = ({ children }: SwayyThemeProviderProps) => {
  useEffect(() => {
    const previousBg = document.body.style.backgroundColor;
    document.body.classList.add("swayy-workspace");
    document.body.style.backgroundColor = swayyColors.pageBg;

    return () => {
      document.body.classList.remove("swayy-workspace");
      document.body.style.backgroundColor = previousBg;
    };
  }, []);

  return (
    <ThemeProvider theme={swayyTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default SwayyThemeProvider;
